import { __assign, __rest } from "tslib";
import React from 'react';
import BrandedButton from '../../../../../Buttons/BrandedButton';
var ConfirmButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(BrandedButton, __assign({ size: "large", variant: "brand-green" }, rest), children));
};
ConfirmButton.displayName = 'ConfirmButton';
export default ConfirmButton;
//# sourceMappingURL=ConfirmButton.js.map